import { IncorporationRequestStatus } from '@commenda/prisma';

export const getWorkRequestStatusName = (
  status: IncorporationRequestStatus
) => {
  switch (status) {
    case IncorporationRequestStatus.NotStarted:
      return 'Not started';
    case IncorporationRequestStatus.InProgress:
      return 'In progress';
    case IncorporationRequestStatus.Submitted:
      return 'Submitted';
    case IncorporationRequestStatus.Filed:
      return 'Filed';
    case IncorporationRequestStatus.Completed:
      return 'Completed';
    default:
      return null;
  }
};
